import React from 'react'
import glamorous from 'glamorous'
import content from 'pp-react-l10n'
import { css } from '../../../lib/paypalphrodite'
import styles from '../funding-option-selector.styles'
import PropTypes from 'prop-types'
import circledCheckMark from '../unified/icons/svg/circledCheckMark.svg'
import glamorousIcon from '../../../lib/glamorous-icon'
import { trackImpression, trackLink } from '../../../lib/analytics/fpti'
let i18n = content('transfer/nobalance')

const Box = glamorous.div({
  display: 'block',
  justifyContent: 'center',
  marginTop: '10%',
})
const Heading = glamorous.h2({
  width: '50%',
  marginLeft: '25%',
  marginBottom: '2%',
})

const ProfileIconSVG = glamorousIcon({
  height: 80,
  width: 80,
  marginLeft: '45%',
  '& svg': { height: 80, width: 80 },
})

ProfileIconSVG.defaultProps = { svg: circledCheckMark }

export class CIPSuccess extends React.Component {
  static propTypes = {
    handleNext: PropTypes.func,
  }

  componentDidMount() {
    this.analyticsStrings = {
      pageGroup: 'main:consumer:p2p:nobalance:cipsuccess',
      pageName: 'main:consumer:p2p:nobalance:cipsuccess:overpanel::',
    }
    trackImpression(
      this.analyticsStrings.pageGroup,
      this.analyticsStrings.pageName
    )
  }

  render() {
    return (
      <Box
        role="dialog"
        aria-label={i18n('nobalance.successTitle')}
        tabIndex="-1"
        data-a11y-overpanel-focus-target="generic-error-open"
        css={{
          ':focus': {
            outline: 'none',
          },
        }}
      >
        <ProfileIconSVG />
        <Heading className="txtCenter ppvx_text--xl3">
          {i18n('nobalance.successTitle')}
        </Heading>
        <button
          data-nemo="nobalance-success-done-button"
          onClick={() => {
            const { pageGroup, pageName } = this.analyticsStrings
            trackLink('done', pageGroup, pageName, 'link')
            this.props.handleNext()
          }}
          className={`${css(styles.nextButton)} vx_btn`}
        >
          {i18n('nobalance.successButton')}
        </button>
      </Box>
    )
  }
}

export default CIPSuccess
